export default __webpack_public_path__ + "static/media/app.4a3dc48e.svg";